const UWM_COMMAND_TYPES = {
    UWM_EVENT: 'UwmEvent',
    UWM_INIT_TIPS_TUTORIALS: 'UWM_INIT_TIPS_TUTORIALS',
    UWM_INIT_LOYALTY: 'UWM_INIT_LOYALTY',
    UWM_INIT_MARKET_LOCALE: 'UWM_INIT_MARKET_LOCALE',
    UWM_INIT_EXTERNAL_LINKS: 'UWM_INIT_EXTERNAL_LINKS',
};

export default UWM_COMMAND_TYPES;
